// Static imports
import PtCreditIndex from '@/views/member/pt/pages/credit'
import PtCreditApplyPage from '@/views/member/pt/pages/credit/apply'
import PtCreditExchangePage from '@/views/member/pt/pages/credit/exchange'
import UseReportPage from '@/views/member/pt/pages/credit/useReport'
import PtCreditPointListPage from '@/views/member/pt/pages/credit/pointList'
import PtCreditSubPtCalPage from '@/views/member/pt/pages/credit/subPTcal'
import PtCreditSubPtPage from '@/views/member/pt/pages/credit/subPt'
import SubCreditIndex from '@/views/member/company/pages/subCredit'
import SubCreditApplyPage from '@/views/member/company/pages/subCredit/apply'
import SubCreditExchangePage from '@/views/member/company/pages/subCredit/exchange'
import SubCreditSubPtPage from '@/views/member/company/pages/subCredit/subPt'
import SubCreditPointListPage from '@/views/member/company/pages/subCredit/pointList'

export default {
  name: 'ptCredit',
  path: '/pt/credit',
  component: PtCreditIndex,
  redirect: {
    name: 'companyCreditApply'
  },
  meta: {
    layout: 'default',
    isActive: false,
    text: '알 관리',
    icon: 'fas fa-egg',
    code: 'LV050000'
  },
  children: [
    {
      name: 'ptCreditApply',
      path: '/pt/credit/apply',
      component: PtCreditApplyPage,
      meta: {
        menuMember: true,
        text: '알 신청내역',
        done: true,
        code: 'LV050100'
      }
    },
    {
      name: 'ptCreditExchange',
      path: '/pt/credit/exchange',
      component: PtCreditExchangePage,
      meta: {
        menuMember: true,
        text: '알 환전내역',
        done: true,
        code: 'LV050200'
      }
    },
    {
      name: 'useReport',
      path: '/pt/credit/useReport',
      component: UseReportPage,
      meta: {
        menuMember: true,
        text: '알 정산내역',
        done: true,
        code: 'LV050700'
      }
    },    
    {
      name: 'ptCreditSubPointList',
      path: '/pt/credit/pointList',
      component: PtCreditPointListPage,
      meta: {
        menuMember: true,
        text: '알 처리내역',
        done: true,
        code: 'LV050300'
      }
    },
    {
      name: 'ptCrediSubPointListDaily',
      path: '/pt/credit/subPTcal',
      component: PtCreditSubPtCalPage,
      meta: {
        menuMember: true,
        text: '알 서브포인트 정산',
        done: true,
        code: 'LV050600'
      }
    },
    {
      name: 'ptCreditsubPt',
      path: '/pt/credit/subPt',
      component: PtCreditSubPtPage,
      meta: {
        menuMember: true,
        text: '서브포인트 충환전내역',
        done: true,
        code: 'LV050500'
      }
    },
    {
      name: 'subCredit',
      path: '/company/subCredit',
      component: SubCreditIndex,
      redirect: {
        name: 'companyCreditApply'
      },
      meta: {
        menuMember: true,
        text: '하부 하부업체 알 관리',
        isActive: false,
        exceptType: 'agency',
        code: 'LV050400'
      },
      children: [
        {
          name: 'subCreditApply',
          path: '/company/subCredit/apply',
          component: SubCreditApplyPage,
          meta: {
            menuMember: true,
            text: '알 신청내역',
            done: true,
            code: 'LV050401'
          }
        },
        {
          name: 'subCreditExchange',
          path: '/company/subCredit/exchange',
          component: SubCreditExchangePage,
          meta: {
            menuMember: true,
            text: '알 환전내역',
            done: true,
            code: 'LV050402'
          }
        },
        {
          name: 'subCreditsubPt',
          path: '/company/subCredit/subPt',
          component: SubCreditSubPtPage,
          meta: {
            menuMember: true,
            text: '서브포인트 충환전',
            done: true,
            code: 'LV050404'
          }
        },
        {
          name: 'subCreditPointList',
          path: '/company/subCredit/pointList',
          component: SubCreditPointListPage,
          meta: {
            menuMember: true,
            text: '서브포인트 적립내역',
            done: true,
            code: 'LV050403'
          }
        }
      ]
    }
  ]
}
